import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, MoreVertical, X } from "lucide-react";
import logo from "../assets/logo.png";
import SearchBar from "./SearchBar";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileSearch, setMobileSearch] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 border border-r border-slate-100${
        scrolled ? "bg-white/80 backdrop-blur shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="relative h-16 px-4 md:px-6 flex items-center">

        {/* LEFT — LOGO */}
        <div className="absolute left-4 md:left-6 flex items-center z-10">
          <Link to="/">
            <img src={logo} alt="EventFlow" className="h-10 w-auto" />
          </Link>
        </div>

        {/* CENTER SEARCH — ONLY LARGE SCREENS */}
        <div className="mx-auto hidden lg:block w-full max-w-lg xl:max-w-2xl">
          <SearchBar placeholder="Search docs…" />
        </div>

        {/* RIGHT — NAV + CTA (DESKTOP ONLY) */}
        <div className="absolute right-4 md:right-6 hidden lg:flex items-center gap-6 text-sm font-medium text-slate-600 z-10">
          <Link to="/docs/overview" className="hover:text-[#C9A24E]">
            Docs
          </Link>
          <Link to="https://eventflow.methologik.com/admin/login" target="_blank" className="hover:text-[#C9A24E]">
            Demo
          </Link>
          {/* <Link to="/" className="hover:text-[#C9A24E]">
            Blogs
          </Link> */}
          <a
            href="https://api.whatsapp.com/send/?phone=923337223262"
            target="_blank"
            rel="noreferrer"
            className="bg-[#C9A24E] text-white px-4 py-2 rounded-full text-sm font-semibold"
          >
            Get in Touch
          </a>
        </div>

        {/* TABLET + MOBILE ICONS */}
        <div className="absolute right-4 md:right-6 flex lg:hidden items-center gap-3">
          <button onClick={() => setMobileSearch((s) => !s)}>
            {mobileSearch ? (
              <X className="h-5 w-5 text-slate-700" />
            ) : (
              <Search className="h-5 w-5 text-slate-700" />
            )}
          </button>
          <button onClick={() => setMenuOpen((o) => !o)}>
            <MoreVertical className="h-5 w-5 text-slate-700" />
          </button>
        </div>
      </div>

      {/* MOBILE / TABLET SEARCH */}
      {mobileSearch && (
        <div className="lg:hidden px-4 pb-3">
          <SearchBar placeholder="Search docs…" />
        </div>
      )}

      {/* MOBILE / TABLET MENU */}
      {menuOpen && (
        <div className="lg:hidden border-t bg-white">
          <nav className="px-4 py-4 flex flex-col gap-4 text-sm text-slate-700">
            <Link to="/docs/overview">Docs</Link>
            <Link to="https://eventflow.methologik.com/admin/login" target="_blank">Demo</Link>
            {/* <Link to="/">Blogs</Link> */}
            <a
              href="https://api.whatsapp.com/send/?phone=923337223262"
              target="_blank"
              rel="noreferrer"
              className="mt-2 inline-flex justify-center bg-[#C9A24E] text-white px-4 py-2 rounded-full"
            >
              Get in Touch
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
